import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Popover,
} from "@material-ui/core";
import STBoardCard from "../../../../assets/styles/molecules/boardCard.module.scss";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { useMemo, useState } from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import STBoardDetail from "../../../../assets/styles/organisms/boardDetail.module.scss";
import { deleteComment } from "../../../../utils/api/deleteComment";
import { useGetTabUUID } from "../../comments/hooks";
import { deleteBoard } from "../../../../utils/api/deleteBoard";

type BoardActionsProps = {
  targetId: number;
  isBoard?: boolean;
  onEdit: () => void;
  onDelete: () => void;
};

const BoardActions = ({
  targetId,
  isBoard = false,
  onEdit,
  onDelete,
}: BoardActionsProps) => {
  const deviceId = useGetTabUUID();
  const [isShowDeleteDialog, setIsShowDeleteDialog] = useState<boolean>(false);
  const [actionsAnchorEl, setActionsAnchorEl] =
    useState<HTMLButtonElement | null>(null);
  const onClickActionsButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    setActionsAnchorEl(event.currentTarget);
  };
  const openCommentActionsPopover = Boolean(actionsAnchorEl);
  const onCloseActionsButton = () => {
    setActionsAnchorEl(null);
  };

  const onOpenDeleteDialog = () => {
    setIsShowDeleteDialog(true);
  };

  const onCloseDialog = () => {
    setIsShowDeleteDialog(false);
  };

  const actions = useMemo(
    () => [
      {
        icon: <EditOutlinedIcon fontSize="inherit" />,
        title: "編集",
        onClick: onEdit,
      },
      {
        icon: <DeleteOutlineOutlinedIcon fontSize="inherit" />,
        title: "削除",
        onClick: onOpenDeleteDialog,
      },
    ],
    []
  );

  const handleDelete = () => {
    if (isBoard) {
      deleteBoard(targetId).then((res) => {
        if (res.isSuccess) {
          onCloseDialog();
          onDelete();
        }
      });
    } else {
      deleteComment(targetId, deviceId).then((res: any) => {
        if (res.isSuccess) {
          onCloseDialog();
          onDelete();
        }
      });
    }
  };

  return (
    <div
      className={`${STBoardCard.actionsContainer} ${
        isBoard ? STBoardCard.actionsContainerForBoard : ""
      }`}
      onClick={(e) => e.stopPropagation()}
    >
      <Button aria-describedby="actions-popover" onClick={onClickActionsButton}>
        <MoreHorizIcon />
      </Button>
      <Popover
        id="actions-popover"
        open={openCommentActionsPopover}
        anchorEl={actionsAnchorEl}
        onClose={onCloseActionsButton}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        style={{ width: "200px" }}
      >
        <div onClick={onCloseActionsButton} style={{ width: "80px" }}>
          {actions.map((action) => {
            const { icon, title, onClick } = action;
            return (
              <div
                className={STBoardCard.actionItem}
                key={title}
                onClick={onClick}
              >
                {icon} <p>{title}</p>
              </div>
            );
          })}
        </div>
      </Popover>

      <Dialog
        open={isShowDeleteDialog}
        onClose={onCloseDialog}
        aria-labelledby="alert-dialog_delete-title"
        aria-describedby="alert-dialog-delete-description"
        className={STBoardDetail.dialog}
      >
        <DialogContent>
          <DialogTitle
            className={STBoardDetail.dialogTitle}
            id="alert-dialog_delete-title"
          >
            削除
          </DialogTitle>
          <DialogContentText
            id="alert-dialog-delete-description"
            className={STBoardDetail.dialogDescription}
          >
            {`\nこの投稿を削除します\n投稿内のコメントも削除されます。\n※一度削除すると元には戻せません。よろしいですか？`}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
          }}
          className={STBoardDetail.buttonGroup}
        >
          <Button className={STBoardDetail.backButton} onClick={onCloseDialog}>
            戻る
          </Button>
          <Button className={STBoardDetail.submitButton} onClick={handleDelete}>
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BoardActions;
